import networkInstance from "../../services/api";
import {
  LOGIN_SUCCESS,
  DRIVER_ADDED_SUCCESS,
  ADMIN_ADDED_SUCCESS,
  VENDOR_ADDED_SUCCESS,
} from "../constant/user";
import toastMessage from "../../toast";
import toast from "react-hot-toast";

export const onSuccessLogin =
  ({ phoneNumber, password }, navigate) =>
  async (dispatch) => {
    try {
      const { data } = await networkInstance.post("member/login", {
        phoneNumber,
        password,
      });
      if (data?.code === 200) {
        localStorage.setItem("token", data?.data?.accessToken);
        const { role, name, phoneNumber, createdAt, available } =
          data?.data?.member || {};
        const userInfo = { role, name, phoneNumber, createdAt, available };
        localStorage.setItem("userInfo", JSON.stringify(userInfo));
        const userObject = {
          token: data?.data?.accessToken,
          userResponse: userInfo,
        };
        dispatch({
          type: LOGIN_SUCCESS,
          payload: userObject,
        });
        navigate("/dashboard");
      } else {
        console.error("Something went wrong");
      }
    } catch (error) {
      toastMessage("error", "Incorrect Email/Phone or Password");
      console.error(error);
    }
  };

export const onAddDriver = (payload, formik) => async (dispatch) => {
  console.log(payload);
  try {
    const { data } = await networkInstance.post("admin/add_driver", payload);
    if (data?.code === 200) {
      dispatch({
        type: DRIVER_ADDED_SUCCESS,
        payload: data?.data,
      });
      toastMessage("success", "driver added successfully");
      formik.resetForm();
    } else {
      console.log("data.data", data.data);
      toastMessage("error", data?.data);
      return {
        error: true,
        message: data.message || "Driver addition failed.",
      }; // Return error if applicable
    }
  } catch (error) {
    toastMessage("error", "Error adding driver.");
    console.error(error);
    return { error: true, message: error.message }; // Return error message
  }
};

export const onAddVendor = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post("admin/add_vendor", payload);
    if (data?.code === 200) {
      dispatch({
        type: VENDOR_ADDED_SUCCESS,
        payload: data?.data,
      });
      toastMessage("success", "Added vendor successfully.");
      formik.resetForm();
    } else {
      console.log("data.data", data.data);
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error.message);
  }
};

export const onAddAdmin = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "super_admin/add_admin",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: ADMIN_ADDED_SUCCESS,
        payload: data?.data,
      });
      toastMessage("success", "Added admin successfully.");
      formik.resetForm();
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error);
  }
};

export const getOrders =
  ({ mobileNumber, fullName, page, limit }) =>
  async (dispatch) => {
    try {
      const params = new URLSearchParams({ page, limit });
      if (mobileNumber) params.append('mobileNumber', mobileNumber);
      if (fullName) params.append('fullName', fullName);
      
      const { data } = await networkInstance.get(
        `orders/get_order_list?${params.toString()}`
      );
      if (data?.code === 200) {
        dispatch({
          type: "GET_ORDERS",
          payload: data?.data,
        });
      }
      console.log("data from order", data);
    } catch (error) {
      // toastMessage("error", "Error fetching order details.")
      console.error(error.message);
    }
  };

export const onTrackOrder = (params) => async (dispatch) => {
  try {
    const { data } = await networkInstance.get(
      `orders/get_order_by_id?id=${params.id}`
    );
    if (data?.code === 200) {
      dispatch({
        type: "TRACK_ORDER",
        payload: data?.data,
      });
    }
    console.log("data from order", data);
  } catch (error) {
    // toastMessage("error", "Error fetching order details.")
    console.error(error.message);
  }
};

export const addManualBarcode = (payload) => async () => {
  try {
    const { data } = await networkInstance.patch(
      "orders/add_manual_barcode",
      payload
    );

    if (data?.code === 200) {
      toastMessage("success", data?.message || "Barcode updated successfully");
      return { success: true, data };
    }

    toastMessage("error", data?.message || data?.data || "Failed to update barcode");
    return { success: false, data };
  } catch (error) {
    toastMessage("error", error?.response?.data?.message || error?.message || "Failed to update barcode");
    return { success: false, error };
  }
};

export const AddFaqs = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post("admin/add_faq", payload);
    if (data?.code === 200) {
      dispatch({
        type: "ADD_FAQ",
        payload: data?.data,
      });
      formik.resetForm();
      toastMessage("success", "FAQs added Successfully");
    }
  } catch (error) {
    toast("error", error.message);
  }
};

export const AddBarCodes = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      `script/add_barcodes?quantity=${payload}`
    );
    if (data?.code === 200) {
      dispatch({
        type: "ADD_BARCODES",
        payload: data?.data,
      });
      formik.resetForm();
      toastMessage("success", "Barcodes added Successfully");
    }
  } catch (error) {
    toast("error", error.message);
  }
};

export const AssignJobsToDriver = (payload, formik) => async (dispatch) => {
  try {
    const response = await networkInstance.post(
      `script/assign_driver`,
      payload
    );
    if (response?.status === 200) {
      if (formik) formik.resetForm();
      toastMessage("success", "Driver has been Assigned");
    }
  } catch (error) {
    console.log(error);
    toast("error", error.message);
  }
};

export const PlaceOrder = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      `admin/place_manual_order`,
      payload
    );
    if (data?.code === 200) {
      formik.resetForm();
      toastMessage("success", data?.message);
    }
  } catch (error) {
    console.log(error);
    toast("error", error.message);
  }
};

export const GetMemberByRole = (params) => async (dispatch) => {
  console.log("Params", params);
  try {
    const { data } = await networkInstance.get(
      `admin/member_detail_role?role=${params}`
    );
    console.log("data.code", data);
    if (data?.code === 200) {
      dispatch({
        type: "MEMBER_ROLE",
        payload: data?.data,
      });
      console.log("Member role data:", data?.data); // Log data received
    } else {
      console.log("Failed to fetch member role data:", data);
    }
  } catch (error) {
    console.error("Error fetching member role:", error);
  }
};

export const GetComplaintByType = (payload) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "admin/list_complaints",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: "COMPLAINT_DATA",
        payload: data?.data,
      });
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error);
    console.error(error.message);
  }
};

export const HandleAssignedComplaint = (payload) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "admin/assign_complaint",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: "ASSIGNED_DATA",
        payload: data?.data,
      });
      toastMessage("success", "This Complaint assigned to you");
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error);
  }
};

export const CloseComplaint = (payload) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "admin/close_complaint",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: "CLOSED_COMPLAINT",
        payload: data?.data,
      });
      toastMessage("success", "This Complaint is closed now");
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error);
  }
};

export const AddCouponAction = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "super_admin/add_coupon",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: "ADD_COUPON",
        payload: data?.data,
      });
      toastMessage("success", "This Coupon is added now");
      formik.resetForm();
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error);
  }
};

export const AddWalletBalanceAction = (payload, formik) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "super_admin/add_wallet_balance",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: "ADD_WALLET_BALANCE",
        payload: data?.data,
      });
      toastMessage("success", "Wallet balance added successfully.");
      formik.resetForm();
      return data.code;
    } else {
      toastMessage(
        "error",
        data?.data || data?.message || "Failed to add wallet balance"
      );
    }
  } catch (error) {
    toastMessage(
      "error",
      error?.response?.data?.message || error.message ||
        "Error adding wallet balance"
    );
    console.error(error);
  }
};

export const GetSupports = (params) => async (dispatch) => {
  try {
    const { data } = await networkInstance.get(
      `admin/get_supports?support=${params.supports}`
    );
    console.log("Data in getSupport action", data);
    if (data?.code === 200) {
      dispatch({
        type: "GET_SUPPORT",
        payload: data?.data,
      });
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", "Error Getting data");
    console.error(error);
  }
};

export const DisableMember = (payload) => async (dispatch) => {
  try {
    const { data } = await networkInstance.post(
      "admin/disable_member",
      payload
    );
    if (data?.code === 200) {
      dispatch({
        type: "DISABLE_MEMBER",
        payload: data?.data,
      });
      toastMessage("success", "Member has been disabled");
      return data.code;
    } else {
      toastMessage("error", data?.data);
    }
  } catch (error) {
    toastMessage("error", error.message);
    console.error(error);
  }
};
